import { formatDistanceToNow } from "date-fns";
import type { FileType } from "@/features/categories/types";

export function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function getFileType(ext: string, contentType: string | null): FileType {
  const e = ext.toLowerCase();
  const ct = contentType?.toLowerCase() ?? "";
  if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(e) || ct.startsWith("image/"))
    return "image";
  if (/\.(mp4|avi|mov|wmv|flv|webm|mkv)$/i.test(e) || ct.startsWith("video/"))
    return "video";
  if (/\.(ppt|pptx)$/i.test(e) || ct.includes("presentation"))
    return "presentation";
  if (
    /\.(xls|xlsx|csv)$/i.test(e) ||
    ct.includes("spreadsheet") ||
    ct.includes("excel")
  )
    return "spreadsheet";
  return "document";
}

export function formatRelative(dateString: string): string {
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return "";
  }
}
